export const YEARS_NEXT = 1;
export const YEARS_BACK = 10;
export const DEFAULT_YEAR_RANGE = YEARS_BACK + 1;